import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useBreadcrumbStore = defineStore('breadcrumb', () => {
  const link = ref<string | null>(null)

  const setLink = (newLink: string | null) => {
    link.value = newLink
  }

  return {
    setLink,
    link
  }
})
